import React from 'react'
import RestaurantCommentContainer from '../../../../Components/Comments/RestaurantCommentContainer/RestaurantCommentContainer'
import Layout from '../../Layout'

const RestaurantComment = () => {
  return (
    <Layout>
      <RestaurantCommentContainer/> 
    </Layout>
  )
}

export default RestaurantComment